<template>
  <div id="container" ref="mapRef" class="mainBox"></div>
  <!-- 使用 vue-baidu-map-3x 提供的 BaiduMap 组件 -->
  <div class="navBox"><Nav curNavId="1" pathUrl='gbzntjs' /></div>
  <div class="left flexColumn">
    <div class="leftBox1 flexColumn">
      <div class="title">设备概况</div>
      <div class="leftInfo1">
        <div class="leftItem1" v-for="(item,index) in state.leftData1">
          <img :src="item.icon" />
          <span class="name">{{item.name}}</span>
          <span class="value">({{item.value}})</span>
        </div>
      </div>
    </div>
    <div class="leftBox2 flexColumn">
      <div class="title">设备统计分析</div>
      <div class="echarts"><LeftLine :listData="state.leftData2" /></div>
    </div>
    <div class="leftBox3">
      <div class="leftItem3" v-for="(item,index) in state.leftData3">
        <div class="iconBox"><img :src="item.icon" /> </div>
        <div class="itemRight">
          <span>{{item.info}}</span>
          <span>{{item.name}}</span>
        </div>
      </div>
    </div>
  </div>
  <div class="right flexColumn">
    <div class="rightBox1 flexColumn">
      <div class="title">水卡统计指标</div>
      <div class="rightInfo1">
        <div class="rightItem1" v-for="(item,index) in state.rightData1" :key="index">
          <div class="valueBg">{{item.value}}</div>
          <div class="name">{{item.name}}</div>
        </div>
      </div>
    </div>
    <div class="rightBox2 flexColumn">
      <div class="title">水卡金额统计</div>
      <div class="echarts"><RightBar /></div>
    </div>
    <div class="rightBox3 flexColumn">
      <div class="title">设备状态</div>
      <div class="rightInfo3">
        <dv-scroll-board :config="state.config" style="width:100%;height:100%" />
      </div>
    </div>
  </div>

</template>

<script setup>
// @ is an alias to /src
import axios from "axios";
import { useRouter } from "vue-router";

import {
  reactive,
  toRefs,
  ref,
  onMounted,
  onUnmounted,
  computed,
  onBeforeUnmount,
  getCurrentInstance,
  defineEmits,
} from "vue";

// todo 项目使用请放开 leaflet 引入
import L from "leaflet";
import "leaflet/dist/leaflet.css";
// import * as L from 'leaflet/dist/leaflet.esm.js';
import Gep from "../utils/map.json";
import ldt from "../components/gbzntyj/ldt.vue";
import dczz from "../components/gbzntyj/dczz.vue";
// import leftPie from "../components/gbzntyj/leftBar.vue";
import footer1 from "@/components/footer.vue";
import Nav from "@/components/nav.vue";
import LeftLine from "../components/shuijia/leftLine";
import RightBar from "../components/shuijia/rightBar";




    // const timer = ref(null);
    const router = useRouter();
    const mapRef = ref(null);
    const state = reactive({
      url: "https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img",
      AccessToken: "",
      imgShow:false,
      leftData1:[
        {name:"在线数量",value:107,icon:require('../assets/img/shuijia/zx.png')},
        {name:"离线数量",value:16,icon:require('../assets/img/shuijia/lx.png')},
        {name:"覆盖面积占比",value:90,icon:require('../assets/img/shuijia/fg.png')},
        {name:"已开启数量",value:4,icon:require('../assets/img/shuijia/zx.png')},
        {name:"已关闭数量",value:104,icon:require('../assets/img/shuijia/lx.png')},
        {name:"错误报警",value:0,icon:require('../assets/img/shuijia/fg.png')}
      ],
      leftData2:{time:['1月', '2月', '3月','4月', '5月', '6月'],value1:[260,320,240,280,130,298,182],value2:[260,320,240,280,130,298,182]},

      leftData3:[
        {name:"使用电量(度)",info:"0.00",icon:require('../assets/img/shuijia/sl.png')},
        {name:" 使用水量(吨)",info:"0.00",icon:require('../assets/img/shuijia/sl.png')},
        {name:"使用金额(元)",info:"0.00",icon:require('../assets/img/shuijia/sl.png')},
        {name:"使用时间(H)",info:"0.00",icon:require('../assets/img/shuijia/sl.png')},
        {name:"灌溉面积(亩)",info:"0.00",icon:require('../assets/img/shuijia/sl.png')},
        {name:"亩均用水量（吨）",info:"0.00",icon:require('../assets/img/shuijia/sl.png')},
        {name:" 亩均用金额(吨)",info:"0.00",icon:require('../assets/img/shuijia/sl.png')}
      ],
      rightData1:[
        {name:"水卡余额",value:1200},
        {name:"近一个月充值",value:0},
        {name:"近一个月消费",value:0}
      ],
      config:{
        header: ['设备名称', '在线/离线', '开关状态'],
        data: [
          ['喷灌1号井', '在线', '关闭'],
          ['喷灌1号井', '离线', '关闭'],
          ['喷灌1号井', '在线', '关闭'],
          ['喷灌1号井', '在线', '关闭'],
          ['喷灌1号井', '离线', '关闭'],
          ['喷灌1号井', '离线', '关闭'],
          ['喷灌1号井', '在线', '关闭'],
          ['喷灌1号井', '在线', '关闭'],
          ['喷灌1号井', '离线', '关闭'],
          ['喷灌1号井', '离线', '关闭']
        ],
        oddRowBGC:"",
        evenRowBGC:"",
        headerBGC:"",
        align:["center","center","center"]
      }

    });

    const emit = defineEmits(["mapLoad"]);
    const boundaryData = Gep;

    const marker = ref();
    const map = ref(null);
    let current = ref(0);

    // 地图底图
    // 第一种
    let mapType = ref("vec");
    let mapLabelType = ref("cva");

    // let mapType1 = ref(
    //   L.tileLayer(
    //     "https://gac-geo.googlecnapps.cn/maps/vt?lyrs=s&x={x}&y={y}&z={z}",
    //     {
    //       subdomains: ["0", "1", "2", "3", "4", "5", "6", "7"],
    //     }
    //   )
    // );

    // let mapType1 = ref(
    //   L.tileLayer(
    //     "http://t0.tianditu.gov.cn/img_w/wmts?SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=img&STYLE=default&TILEMATRIXSET=w&FORMAT=tiles&TILEMATRIX={z}&TILEROW={y}&TILECOL={x}&tk=2543bd43d4f3f8b748d7ee2ecb82f74a",
    //     {
    //       subdomains: ["0", "1", "2", "3", "4", "5", "6", "7"],
    //     }
    //   )
    // );
    let mapType1 = ref(
      L.tileLayer(
        "https://map1.aikenong.com.cn/maps/vt/lyrs=y&hl=zh-CN&gl=cn&scale=2&src=app&x={x}&y={y}&z={z}",
        {
          subdomains: ["0", "1", "2", "3", "4", "5", "6", "7"],
        }
      )
    );
    let mapLabelType1 = ref(
      L.tileLayer(
        "https://t0.tianditu.gov.cn/cia_w/wmts?SERVICE=WMTS&VERSION=1.0.0&REQUEST=GetTile&LAYER=cia&STYLE=default&FORMAT=tiles&TILEMATRIXSET=w&TILEMATRIX={z}&TILEROW={y}&TILECOL={x}&tk=2543bd43d4f3f8b748d7ee2ecb82f74a",
        {
          subdomains: ["0", "1", "2", "3", "4", "5", "6", "7"],
        }
      )
    );
    // let mapLabelType1 = ref(
    //   L.tileLayer(
    //     "https://t{s}.tianditu.gov.cn/" +
    //       "cva" +
    //       "_w/wmts?SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=" +
    //       "cva" +
    //       "&STYLE=default&TILEMATRIXSET=w&FORMAT=tiles&TILECOL={x}&TILEROW={y}&TILEMATRIX={z}&tk=2543bd43d4f3f8b748d7ee2ecb82f74a",
    //     {
    //       subdomains: ["0", "1", "2", "3", "4", "5", "6", "7"],
    //     }
    //   )
    // );

    const initMap = () => {
      map.value.addLayer(mapType1.value);
      map.value.addLayer(mapLabelType1.value);
      map.value.on("click", ({ latlng }) => {
        console.log("坐标：", Object.values(latlng));
      });

      return map.value;
    };

    const mapObj = ref();

    // 在 onMounted 中初始化地图
    onMounted(() => {
      // 获取视频AccessToken
      state.AccessToken = localStorage.getItem("AccessToken");
      console.log(state.AccessToken);
      const text = "为深入贯彻落实党的二十大精神，按照新形势下国家粮食安全和农业可持续发展的总体要求，深入贯彻落实“藏粮于地、藏粮于技”战略，以推进农业现代化为目标，以促进农业可持续发展为主线，加强高标准农田建设，支持生态综合治理，提高农田抗御旱涝灾害的能力，加强农业基础设施建设，改善农业生产条件，提高农业特别是粮食综合生产能力。上蔡县委、县政府根据全县经济社会发展需求和自身条件，特别是县域耕地数量、质量和农业发展现状，经过多次规划选址、研讨论证，最终选定位于县城西南部的无量寺、大路李、黄埠3个乡镇的14个行政村和1个农场、1个种子站，集中连片5万亩耕地，作为县农业现代化高标准农田示范区。其中，以吴宋湖农场周边区域1.5万亩作为核心区先行打造。";
      state.textList = chunkString(text, 44);
      


      map.value = L.map(mapRef.value, {
        center: [33.248258780732435, 114.18800353654662],

        // center: [114.182633, 33.240019],
        zoom: 13,
        minZoom: 3,
        maxZoom: 19,
        noWrap: true,
        // dragging: false,
        zoomControl: true,
        attributionControl: false,
      });
      mapObj.value = initMap();
      // createMarkers();
      loadBoundary();
      for (const markerDatum of markersData) {
        for (const latlng of markerDatum.locations) {
          const iconPath = require(`../assets/img/icon/new/${markerDatum.iconName}`);

          const marker = createAndAddMarker(latlng, {
            title: `地标`,
            icon: L.icon({
              iconUrl: iconPath,
              iconSize: [34, 48], // 图标大小
              iconAnchor: [22, 94], // 图标锚点
              popupAnchor: [-3, -76], // 弹出窗锚点
            }),
          });

          // 假设没有针对每个点定制的弹出内容，可以根据需求添加
          // const popupContent = `<div style='width: 200px; height: 100px;font-size: 20px; color: aqua;'>${
          //   markerDatum.title ? markerDatum.title : "地标"
          // }</div>`;
          // marker.bindPopup(popupContent);
        }
      }
    });
    // 新增一个清除所有标记的方法
    function clearMarkers() {
      // 如果map.value存在并且有layers，则遍历删除所有标记
      if (map.value && map.value.eachLayer) {
        map.value.eachLayer((layer) => {
          if (layer instanceof L.Marker) {
            map.value.removeLayer(layer);
          }
        });
      }
    }
    // 假设有个按钮点击事件，用buttonClick表示
    function buttonClick(index) {
      // 清除所有已存在的标记
      clearMarkers();

      // 筛选出iconName为"1.png"的标记数据
      const filteredMarkers = markersData.find(
        (markerDatum) => markerDatum.iconName === index + ".png"
      );

      // 遍历筛选出来的标记数据，添加到地图上
      if (filteredMarkers) {
        for (const latlng of filteredMarkers.locations) {
          const iconPath = require(`../assets/img/icon/new/${filteredMarkers.iconName}`);

          const marker = createAndAddMarker(latlng, {
            title: `地标`,
            icon: L.icon({
              iconUrl: iconPath,
              iconSize: [34, 48],
              iconAnchor: [22, 94],
              popupAnchor: [-3, -76],
            }),
          });

          // 添加自定义的弹出内容
          // const popupContent = `<div style='width: 200px; height: 100px;font-size: 20px; color: aqua;border: 1px solid #19e1cb;'>${
          //   filteredMarkers.title ? filteredMarkers.title : "地标"
          // }</div>`;
          // marker.bindPopup(popupContent);
        }
      }
    }

    // 定义一个函数用来创建和添加Marker
    function createAndAddMarker(latlng, options = {}) {
      const marker = L.marker(latlng, options);
      marker.addTo(map.value);
      return marker;
    }
    const markersData = [
      {
        locations: [
          [33.24496,114.19039],
          [33.24478,114.19031],
          [33.24477,114.19036],
        ],
        iconName: "1.png",
        // 其他相关属性...
      },
      // ...
      {
        locations: [
          [33.244863,114.190435],
        ],
        iconName: "2.png",
        // 其他相关属性...
      },
      // ...
      {
        locations: [
          [33.2342147, 114.1648178], 
          [33.2521705, 114.1651687], 
          [ 33.2448196, 114.1902923], 
          [ 33.2342147, 114.1648178],
          [33.237019, 114.16764], 
          [33.2448196, 114.1902923], 
          [33.1868121, 114.185881], 
          [ 33.235762, 114.164232], 
          [33.2448196, 114.1902923], 
          [33.235761, 114.1644], 
          [ 33.2521705, 114.1651687], 
          [33.2987955, 114.1845949], 
          [33.244885, 114.189318], 
          [33.2087364, 114.1830902], 
          [33.236647, 114.167541], 
          [33.245275, 114.190154], 
          [33.239533, 114.191423], 
        ],
        iconName: "3.png",
        // 其他相关属性...
      },
      // ...
      {
        locations: [
          [33.2520408, 114.2499465],
        ],
        iconName: "4.png",
        // 其他相关属性...
      },
      {
        locations: [
          [33.2520408, 114.2499465],
        ],
        iconName: "5.png",
        // 其他相关属性...
      },
      {
        locations: [
          [33.2520408, 114.2499465],
          [33.2472305, 114.2018966],
          [33.2596416, 114.2135464],
          [33.2454834, 114.2370758], 
          [34.7224769, 114.3508834], 
          [33.2517814, 114.162445],
          [34.737783, 114.3608285], 
          [33.2420481, 114.2330525],
          [33.2524084, 114.2173239],
          [33.2397003, 114.2182464], 
          [33.2454795, 114.2488632],
          [33.2376858, 114.2018937], 
          [33.2465529, 114.2394154], 
          [33.2436752, 114.1551513],
          [33.2509422, 114.2337212], 
          [33.2517814, 114.162445], 
          [33.270504, 114.1541595], 
          [33.2486135, 114.2431322],
        ],
        iconName: "6.png",
        // 其他相关属性...
      },
    ];

    function createDashedPolyline(feature, style) {
      const latLngs = feature.geometry.coordinates;
      if (feature.geometry.type === "Polygon") {
        // 取外圈线作为多段线处理
        latLngs = [latLngs[0]];
      } else if (feature.geometry.type === "MultiPolygon") {
        // 处理多个多边形，这里仅取第一个外圈线
        latLngs = [latLngs[0][0]];
      }

      const options = {
        ...style,
        dashArray: [5, 5], // 虚线长度与间距
        lineCap: "round", // 线头样式，可选
        lineJoin: "round", // 线交接处样式，可选
      };

      return L.polyline(latLngs, options);
    }

    // 添加行政区划边界的逻辑
    const loadBoundary = () => {
      L.geoJSON(boundaryData, {
        onEachFeature: function (feature, layer) {
          let style;

          switch (feature.properties.T) {
            case "未建成":
              style = {
                color: "green",
                fillColor: "green",
                fillOpacity: 0.25,
                dashArray: [5, 5],
                weight: 1,
              };
              break;
            case "其他":
              style = {
                color: "green",
                fillColor: "green",
                fillOpacity: 0.25,
                dashArray: [5, 5],
                weight: 1,
              };
              break;
            default:
              style = {
                color: "white",
                fillColor: "red",
                fillOpacity: 0.25,
                dashArray: [5, 5],
                weight: 1,
              };
          }

          if (
            feature.geometry.type === "Polygon" ||
            feature.geometry.type === "MultiPolygon"
          ) {
            // 设置填充样式
            layer.setStyle(style);

            // 处理每个外环线为虚线
            feature.geometry.coordinates.forEach((ring, index) => {
              if (index === 0 || feature.geometry.type === "Polygon") {
                // 对于多边形，只处理外环线
                const dashedLine = createDashedPolyline(
                  { geometry: { coordinates: [ring] } },
                  style
                );
                map.value.addLayer(dashedLine);
              }
            });
          } else if (
            feature.geometry.type === "LineString" ||
            feature.geometry.type === "MultiLineString"
          ) {
            const dashedLine = createDashedPolyline(feature, style);
            map.value.addLayer(dashedLine);
          }

          // 添加原始图层到地图上（用于显示填充区域）
          map.value.addLayer(layer);
        },
      }).addTo(map.value);
    };

    const removeMap = () => {
      if (mapObj.value) {
        mapObj.value.remove();
      }
    };


    
    function chunkString(str, chunkSize) {
      if (str.length <= chunkSize) {
        return [str];
      }
      return [str.slice(0, chunkSize), ...chunkString(str.slice(chunkSize), chunkSize)];
    }

    onUnmounted(() => {
      removeMap();
    });
    onBeforeUnmount(() => {
      // clearInterval(timer.value);
    });
</script>
<style lang="less" scoped>
body {
  background-size: cover;
  line-height: 1.15;
}


.navBox{
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;
  width: 100%;
  height: 150px;
  background: linear-gradient( to bottom, rgba(3, 14, 25, 1) 0%,  rgba(3, 14, 25, 0.7) 60%,  rgba(3, 14, 25, 0));
}
.mainBox {
  width: 100%;
  height: 100vh;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2;
}
.flexColumn{
  display: flex;
  flex-direction: column;
}
.echarts{
  width: 100%;
  flex: 1;
}
.title{
  width:100%;
  height: 40px;
  font-weight: bold;
  background: url("../assets/img/huanjing/xbt.png") no-repeat left bottom;
  color: #fff;
  font-size: 20px;
  line-height: 20px;
  text-align: left;
  padding-left: 30px;
}
.left,.right{
  position: fixed;
  top: 71px;
  width: 432px;
  height: calc(100% - 71px);
  background: url("../assets/img/huanjing/ck.png") no-repeat;
  z-index: 1000;
  padding: 20px 0;
}

.left{
  left: 10px;
  .leftBox1{
    height: 354px;
    align-items: center;
    .leftInfo1{
      display: flex;
      flex-wrap: wrap;
      padding: 20px 0;
      .leftItem1{
        width: 33%;
        display: flex;
        flex-direction: column;
        align-items: center;
        font-size: 16px;
        line-height: 24px;
        color: #fff;
        img{
          width: 98px;
          height: 77px;
          margin-bottom: 10px;
        }
        .value{
          color: #44C6D6;
        }
      }
      .leftItem1:nth-child(2),.leftItem1:nth-child(5){
        .value{
          color: #F3D05C;
        }
      }
      .leftItem1:nth-child(3n){
        .value{
          color: #44C6D6;
        }
      }

    }

  }
  .leftBox2{
    flex: 1;
  }
  .leftBox3{
    height: 255px;
    padding-bottom: 14px;
    display: flex;
    flex-wrap: wrap;
    padding-left: 40px;
    .leftItem3{
      width: 50%;
      display: flex;
      align-items: center;
      //padding-left: 40px;
      .iconBox{
        width: 45px;
        height: 42px;
        background: url("../assets/img/shuijia/sy.png") no-repeat;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: 10px;
        img{
          width: 24px;
          height: 24px;
        }
      }
      .itemRight{
        span{
          display: block;
          text-align: left;
        }
        span:first-child{
          font-size: 16px;
          font-weight: bold;
          color: #00FFFF;
          margin-bottom: 5px;
        }
        span:last-child{
          font-size: 14px;
          color:#fff
        }
      }
    }
  }
}
.right{
  right: 10px;
  .rightBox1{
    width: 100%;
    height: 260px;
    .rightInfo1{
      flex: 1;
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      justify-content: center;
      padding: 30px 20px;
      .rightItem1{
        width: 50%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        .valueBg{
          width: 172px;
          height: 74px;
          background: url("../assets/img/shuijia/sk.png") no-repeat;
          text-align: center;
          line-height: 74px;
          color: #fff;
          font-size: 14px;
          padding: 0 57px 0 59px;
        }
        .name{
          font-size: 16px;
          line-height: 20px;
          color: #fff;
        }
      }
      .rightItem1:first-child{
        width: 100%;
      }
    }
  }
  .rightBox2{
    flex: 1;
  }
  .rightBox3{
    height: 352px;
    .rightInfo3{
      width: 100%;
      flex: 1;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      padding: 20px 14px 20px;
      ::v-deep .header{
        border-bottom: 1px solid #16B092;
        font-weight: bold;
      }
      ::v-deep .row-item{
        border-bottom:1px dashed #6F7378 ;
      }
      ::v-deep .dv-scroll-board{
        border-bottom: 1px solid #107867;
      }

    }
  }
}


</style>
